const qs = require('qs')
const { showError } = require('../../libs/helper')

module.exports = {
  getGedung: (g, data) => {
    /* Call Api
    sensus-pengguna-b/bmd/list-register
    */
    const result = g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}api/sensus-pengguna-b/ref/get-gedung`,
      method: 'post',
      data: qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },
}
